module.exports = __webpack_public_path__ + "img/emerald-hill-logo.16c6491f.svg";